import { 
  IonModal, 
  IonHeader, 
  IonToolbar, 
  IonTitle, 
  IonButtons, 
  IonButton, 
  IonIcon, 
  IonContent 
} from '@ionic/react';
import { close, trophy } from 'ionicons/icons';
import { formatDistanceToNow, parseISO } from 'date-fns';
import { TeamMember } from '../../types/teamSummary';

interface BadgesModalProps {
  member: TeamMember;
  isOpen: boolean;
  onClose: () => void;
}

export function BadgesModal({ member, isOpen, onClose }: BadgesModalProps) {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{member.displayName}'s Badges</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>
              <IonIcon icon={close} slot="icon-only" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {!member.badges || member.badges.length === 0 ? (
          <div className="py-8">
            <IonIcon icon={trophy} />
            <p>No badges earned yet</p>
          </div>
        ) : (
          <div className="flex flex-wrap gap-4">
            {member.badges.map((badge) => (
              <div
                key={badge.id}
                className="w-full flex gap-4"
              >
                <span>{badge.icon}</span>
                <div className="flex-1">
                  <div>{badge.name}</div>
                  <p>{badge.description}</p>
                  {badge.earnedDate && (
                    <p>
                      Earned {formatDistanceToNow(parseISO(badge.earnedDate), { addSuffix: true })}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </IonContent>
      <div className="px-4 py-3 border-t flex items-center justify-center">
        <IonButton
          onClick={onClose}
          color="primary"
        >
          Close
        </IonButton>
      </div>
    </IonModal>
  );
}

